
import { withStyles } from "@material-ui/core/styles";
import TimelineItem from "@material-ui/lab/TimelineItem";

const TimelineItemStyled = withStyles({
  missingOppositeContent: {
    "&:before": {
      display: "none"
    }
  }
})(TimelineItem);

export { TimelineItemStyled }


// WEBPACK FOOTER //
// ./src/components/common/TimelineStyled.js